module.exports = __webpack_public_path__ + "static/Politykaprywatnosci-8a161e331791544667e1f4d6e90392e0.pdf";